<template>
    <div class="modal-2" @click="closeModal" v-if="show">
            <div class="modal-log" >
                <form class='form-modal'>
					<div class="modal-head">
						<h3 class="title-text">Conversa</h3>
						<span @click='btnClose' class='closeBtn'>&times;</span>
					</div>

                    <itemMessage
				    v-for="(msgItem, index) in fulllog.msgs" :key="'item-mensagen-'+index"
				    :avatar="fulllog.meuAvatar" :is-proprio="msgItem.isProprio" :data="msgItem.data" :mensagem="msgItem.mensagem"
			        ></itemMessage>

                </form>

            </div>
        </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
import itemMessage from '../mensagem/ItemMensagen';

export default {
    data: function(){
        return {
            show: false, 
            fulllog: [] 
        }
    },
    computed:{
        ...mapGetters(['getlogchat'])
    },
    methods:{
        btnClose(event){
            this.show = false;
        },
        closeModal(event){
            if(event.target.className != 'modal-2')
                return
            
            this.show = false; 
        }
    },
    watch: {
        getlogchat: function(){
            this.fulllog = this.getlogchat;
            this.show = true;
        }
    },
    mounted(){
        window?.addEventListener("keyup", e => {
            if(e.key == 'Escape') this.show = false;
        });
    },
    components:{
        itemMessage
    }
}
</script>

<style scoped>
    .modal-log{
        position: relative;
        margin: 10% auto;
        max-height: 50em;
        padding: 30px;
        max-width: 60em;
        border-radius: 4px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.16);
        background-color: #FAFAFA;
        overflow-y: auto;
    }
</style>